// Preserve old museum links without duplicating the combined catalogue/FAQ.
class MaBeMuseumRedirect extends HTMLElement {
  connectedCallback() {
    if (window.Shopify?.designMode) return;
    const destination = new URL(this.dataset.url, location.origin);
    if (destination.origin === location.origin && destination.pathname !== location.pathname) location.replace(destination.href);
  }
}
if (!customElements.get('mabe-museum-redirect')) customElements.define('mabe-museum-redirect', MaBeMuseumRedirect);
